import React from 'react';
import { useFormContext } from "react-hook-form";
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { MailIcon, GlobeIcon, PhoneIcon, Instagram, Youtube, Facebook } from 'lucide-react';
import FormField from '@/components/form/FormField';

const ContactSection = () => {
  const { register } = useFormContext();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium flex items-center gap-2">
        <MailIcon size={18} />
        Contacto
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <FormField
          name="email"
          label="Correo electrónico"
          icon={MailIcon}
          type="email"
        />
        <div className="form-group">
          <Label className="form-label flex items-center gap-2">
            <GlobeIcon size={16} />
            Página web
          </Label>
          <Input 
            {...register('website')}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <Label className="form-label flex items-center gap-2">
            <PhoneIcon size={16} />
            Teléfono
          </Label>
          <Input 
            {...register('phone')}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <Label className="form-label flex items-center gap-2">
            <PhoneIcon size={16} />
            WhatsApp
          </Label>
          <Input 
            {...register('whatsapp')}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <Label className="form-label flex items-center gap-2">
            <Instagram size={16} />
            Instagram
          </Label>
          <Input 
            {...register('instagram')}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <Label className="form-label flex items-center gap-2">
            <Facebook size={16} />
            Facebook
          </Label>
          <Input 
            {...register('facebook')}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <Label className="form-label flex items-center gap-2">
            <Youtube size={16} />
            Youtube
          </Label>
          <Input 
            {...register('youtube')}
            className="form-input"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
